// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3Od3V","column":"style_column__WmYWj","row":"style_row__12Rht"};